export const filterText = (testString: string, rule: unknown): boolean => {
  if (typeof rule !== 'string') { return false }
  return new RegExp(`(.)*${rule}(.)*`, 'i').test(testString)
}

export const filterTextByArray = (testString: string, array: string[]): boolean => array.includes(testString)
